import qs from 'qs'

export const utmQueryString = (): string => {
  const params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const utmQueryParams = Object.keys(params)
    .filter((key) => key.startsWith('utm_'))
    .map((key) => `${key}=${params[key]}`)
    .join('&')
  return utmQueryParams ? `?${utmQueryParams}` : ''
}
